var constants = require('../constants');
var _ = require('lodash');

var SetResponse = (function() {

    var _setCurrentResponse = function(data) {
        return function(dispatch, getState) {
            var currentResponse = getState().responses.currentResponse;
            var newCurrentResponse;

            var option = data.option || {};
            delete data.option;

            var dataIndexInCurrentResponse = currentResponse.map(function(x) {
                return x.tag + '_' + x.value;
            }).indexOf(data.tag + '_' + data.value);

            // Check against rowValue to update responses in matix layout
            var rowInCurrentResponse = currentResponse.map(function(x) {
                return x.rowValue;
            }).indexOf(data.rowValue);

            if (option.hasOwnProperty('selected') && !option.hasOwnProperty('matrix')) {
                if(!option.allowMulti || data.unique){ // single
                    if(option.selected){
                        newCurrentResponse = [data];
                    }else{
                        newCurrentResponse = [];
                    }
                }else{ // multiple
                    if(option.selected){
                        // remove unique choice
                        currentResponse = currentResponse.filter(function(x){
                            return !x.unique;
                        });

                        // upsert
                        if(dataIndexInCurrentResponse > -1){
                            currentResponse[dataIndexInCurrentResponse] = data;
                            newCurrentResponse = currentResponse;
                        }else{
                            newCurrentResponse = currentResponse.concat(data);
                        }
                    }else{
                        newCurrentResponse = currentResponse
                            .slice(0, dataIndexInCurrentResponse)
                            .concat(currentResponse.slice(dataIndexInCurrentResponse + 1));
                    }
                }
            } else if (option.hasOwnProperty('matrix')) {
                // Handle matrix responses for single and multi situation; Also clear on uniques.
                if(!option.allowMulti){ 
                    // Single option matrix rows
                    if (dataIndexInCurrentResponse > -1) {
                        currentResponse[dataIndexInCurrentResponse] = data;
                        newCurrentResponse = currentResponse;
                    } else if (rowInCurrentResponse > -1) {
                        currentResponse[rowInCurrentResponse] = data;
                        newCurrentResponse = currentResponse;
                    } else {
                        newCurrentResponse = currentResponse.concat(data);
                    }
                }else{
                    // Multi option matrix rows
                    if (data.unique && option.selected) {
                        // Clear row responses if unique item selected
                        currentResponse = _.reject(currentResponse, (response) => {
                            return response.rowValue === data.rowValue;
                        });                        
                    } else if (option.selected) {
                        // Remove unique choice if non-unique selected
                        currentResponse = _.reject(currentResponse, (response) => {
                            return (response.rowValue === data.rowValue) && response.unique;
                        });
                    }

                    if (rowInCurrentResponse > -1 && dataIndexInCurrentResponse > -1) {
                        // Remove data if already in response
                        newCurrentResponse = currentResponse
                        .slice(0, dataIndexInCurrentResponse)
                        .concat(currentResponse.slice(dataIndexInCurrentResponse + 1));

                    } else { 
                        // Otherwise add new selection to array
                        newCurrentResponse = currentResponse.concat(data);
                    }
                }
            } else {
                newCurrentResponse = [data];
            }

            dispatch(_replaceCurrentResponse(newCurrentResponse));

        };
    }

    var _replaceCurrentResponse = function(data) {
        return {
            type: constants.REPLACE_CURRRENT_RESPONSE,
            data: data
        };
    }

    return {
        setCurrentResponse: _setCurrentResponse
    }
})();

module.exports = SetResponse;



// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/set-current-response.js